import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {tap} from 'rxjs/operators';
import {JwtHelperService} from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private _http: HttpClient, private _jwtHelper: JwtHelperService) {
  }

  public get isLoggedIn(): boolean {
    return (
      localStorage.getItem('access_token') !== null &&
      !this._jwtHelper.isTokenExpired()
    );
  }

  public get pidm(): string {
    return this._jwtHelper.decodeToken().nameid;
  }

  public login(token: string) {
    return this._http
      .post(
        'auth/login',
        {
          token: token,
        },
        {responseType: 'text'}
      )
      .pipe(tap((data) => localStorage.setItem('access_token', data)));
  }

  public logout() {
    localStorage.removeItem('access_token');
  }

}
